import type { ReactNode } from 'react';

import { Box } from '@mui/material';

export interface TablePageShellProps {
  children: ReactNode;
  footer?: ReactNode;
}

/**
 * Shared shell for table-heavy pages.
 *
 * Keeps the table body in flow and pins the footer area to the bottom of the
 * scroll viewport. The footer is typically a pagination bar.
 */
export function TablePageShell({ children, footer }: TablePageShellProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
        width: '100%',
        alignSelf: 'stretch',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
        }}
      >
        {children}
      </Box>
      {footer ? (
        <Box
          sx={{
            mt: 0.5,
            pt: 1,
            pb: 1,
            backgroundColor: 'background.default',
            borderTop: (t) => `1px solid ${t.palette.divider}`,
            flexShrink: 0,
            position: 'relative',
            zIndex: 1,
          }}
        >
          {footer}
        </Box>
      ) : null}
    </Box>
  );
}
